import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-prominent-location-disclosure-modal',
  templateUrl: './prominent-location-disclosure-modal.component.html',
  styleUrls: ['./prominent-location-disclosure-modal.component.scss'],
})
export class ProminentLocationDisclosureModalComponent {
  constructor(private modalController: ModalController) {}

  protected accept(): Promise<boolean> {
    return this.modalController.dismiss({ accepted: true });
  }

  protected decline(): Promise<boolean> {
    return this.modalController.dismiss({ accepted: false });
  }
}
